import normalizeTranslationText from './translation-text';

const DEFAULT_NAMESPACE = 'translation';
const ENGLISH_LANGUAGE = 'en';

const isAvailableTranslation = (value) =>
  value !== undefined && value !== null && value !== '';

const getActiveLanguage = (i18n) => i18n.resolvedLanguage || i18n.language;

const getResourceCaseInsensitive = (i18n, language, key) => {
  if (!key || !language) return undefined;

  const exactValue = i18n.getResource(language, DEFAULT_NAMESPACE, key);
  if (isAvailableTranslation(exactValue)) {
    return exactValue;
  }

  const resources = i18n.getResourceBundle(language, DEFAULT_NAMESPACE);
  if (!resources) return undefined;

  const normalizedKey = key.toLowerCase();
  const matchingKey = Object.keys(resources).find(
    (resourceKey) => resourceKey.toLowerCase() === normalizedKey
  );

  const matchingValue = matchingKey ? resources[matchingKey] : undefined;

  return isAvailableTranslation(matchingValue) ? matchingValue : undefined;
};

const resolveWithEnglishFallback = (i18n, key, options = {}) => {
  const languages = [getActiveLanguage(i18n), ENGLISH_LANGUAGE]
    .filter(Boolean)
    .filter((language, index, values) => values.indexOf(language) === index);

  const resolvedValue = languages
    .map((language) => getResourceCaseInsensitive(i18n, language, key))
    .find(isAvailableTranslation);

  if (options.returnObjects) {
    return resolvedValue ?? key;
  }

  if (!isAvailableTranslation(resolvedValue)) return key;

  return normalizeTranslationText(resolvedValue);
};

export {
  getResourceCaseInsensitive,
  resolveWithEnglishFallback,
};

export default resolveWithEnglishFallback;